/* Kiddostoys — comportement du tiroir panier custom.

   Charge par snippets/cart-drawer.liquid, en dehors de <cart-drawer> : le
   contenu du tiroir est reconstruit par innerHTML a chaque mise a jour, donc
   un script pose a l'interieur ne serait jamais rejoue. Tout passe par de la
   delegation sur document.

   Trois choses a faire ici, et rien d'autre :
   1. le header custom n'a pas de #cart-icon-bubble, donc le tiroir n'est
      branche sur rien : on ouvre au clic sur les liens panier, on neutralise
      le fetch de cette section, et on repeint la pastille nous-memes ;
   2. ajouter un produit d'upsell sans quitter le tiroir ;
   3. ne jamais laisser passer deux ajouts concurrents. */

(function () {
  'use strict';
  if (window.__kdCartDrawer) return;
  window.__kdCartDrawer = true;

  var CART_LINK = 'a[href$="/cart"], a[href$="/cart/"]';
  var adding = false;

  function drawer() {
    return document.querySelector('cart-drawer');
  }

  /* ── 1. Raccorder le tiroir au header ─────────────────────────── */

  /* sections/header-custom.liquid rend un simple <a href="/cart"> sans
     id="cart-icon-bubble". CartDrawerItems.getSectionsToRender() reclame
     pourtant cet element et fait document.getElementById(...).querySelector(...)
     sans garde : sans ce correctif, changer une quantite dans le tiroir jette
     un TypeError et affiche une erreur de panier a l'utilisateur. */
  function unwireCartIconBubble() {
    var ctor = window.customElements && customElements.get('cart-drawer-items');
    if (!ctor || ctor.prototype.__kdPatched) return false;
    ctor.prototype.getSectionsToRender = function () {
      return [{ id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' }];
    };
    ctor.prototype.__kdPatched = true;
    return true;
  }

  if (!unwireCartIconBubble()) {
    customElements.whenDefined('cart-drawer-items').then(unwireCartIconBubble);
  }

  /* Pastille de compte du header. Le Liquid ne la rend que si le panier n'est
     pas vide, donc il faut savoir la creer et la retirer. */
  function paintCount(count) {
    document.querySelectorAll('.hc__icon-btn[href]').forEach(function (link) {
      if (!/\/cart\/?$/.test(link.getAttribute('href') || '')) return;
      var bubble = link.querySelector('.hc__cart-count');
      if (count > 0) {
        if (!bubble) {
          bubble = document.createElement('span');
          bubble.className = 'hc__cart-count';
          link.appendChild(bubble);
        }
        bubble.textContent = count;
      } else if (bubble) {
        bubble.remove();
      }
    });
  }

  /* Le compte affiche est celui des produits ACHETES : ni les supplements du
     puzzle, ni les exemplaires cadeau. Sinon un lot de 3 jouets et ses 3 ebooks
     offerts font 6, et le nombre ne dit plus rien au client. Le Liquid de
     l'en-tete applique exactement la meme regle. */
  function comptePayants(cart) {
    if (!cart || !cart.items) return 0;
    return cart.items.reduce(function (n, i) {
      var props = i.properties || {};
      var tags = i.product_tags || i.tags || [];
      var technique =
        props._For ||
        props._Free_gift ||
        i.product_type === 'Add-on' ||
        tags.indexOf('add-on') > -1 ||
        tags.indexOf('free-gift') > -1;
      return technique ? n : n + i.quantity;
    }, 0);
  }

  function syncCount() {
    return fetch(window.routes ? routes.cart_url + '.js' : '/cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var n = comptePayants(cart);
        paintCount(n);
        return n;
      })
      .catch(function () {
        return null;
      });
  }

  /* ── Le cadeau ne survit pas seul ─────────────────────────────── */

  /* L'exemplaire cadeau de l'ebook est un produit a 0,00 $ : c'est ce qui le
     rend gratuit sans remise, donc sans conflit avec les remises de palier.
     Revers de la medaille : si le client retire les jouets, la ligne cadeau
     reste et le panier tombe a 0,00 $. On peut alors commander un ebook gratuit
     sans rien acheter.

     On retire donc les lignes cadeau des qu'il ne reste plus rien de payant, et
     on les ramene a 1 si quelqu'un s'amuse a monter la quantite. Le controle se
     fait sur le panier reel, pas sur le DOM : les proprietes commencant par _
     ne sont pas rendues. */
  function estCadeau(item) {
    return !!(item.properties && item.properties._Free_gift);
  }

  function nettoyerCadeaux() {
    return fetch(window.routes ? routes.cart_url + '.js' : '/cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) return false;
        var cadeaux = cart.items.filter(estCadeau);
        if (!cadeaux.length) return false;

        var updates = {};
        var aChanger = false;
        var payants = cart.items.filter(function (i) {
          return !estCadeau(i);
        });

        if (!payants.length) {
          /* Plus rien de payant : le cadeau n'a plus de raison d'etre. */
          cadeaux.forEach(function (i) {
            updates[i.key] = 0;
            aChanger = true;
          });
        } else {
          /* Un cadeau par exemplaire achete : un lot de 3 donne 3 ebooks. Le
             plafond est donc le nombre d'articles payants du panier, et pas 1.
             Sans plafond, il suffirait de monter la quantite de la ligne cadeau
             pour se servir. */
          var achetes = payants.reduce(function (n, i) {
            return n + i.quantity;
          }, 0);
          cadeaux.forEach(function (i) {
            if (i.quantity > achetes) {
              updates[i.key] = achetes;
              aChanger = true;
            }
          });
        }

        if (!aChanger) return false;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function () {
          return true;
        });
      })
      .catch(function () {
        return false;
      });
  }

  /* constants.js et pubsub.js declarent PUB_SUB_EVENTS et subscribe en const et
     en function au niveau global : le premier n'est PAS une propriete de window,
     seul typeof le voit. Ils sont charges en defer depuis le head, donc prets
     avant ce fichier. */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      /* On refetche toujours : `cartData.item_count` compte les lignes techniques,
         et c'est justement ce qu'on ne veut plus afficher. */
      syncCount();
      /* Toute modification du panier peut laisser le cadeau tout seul. */
      nettoyerCadeaux().then(function (nettoye) {
        if (nettoye) repaint(null).then(syncCount);
      });
    });
  }

  /* Au chargement aussi : un panier peut avoir ete laisse dans cet etat lors
     d'une visite precedente, le cookie de panier survit. */
  nettoyerCadeaux().then(function (nettoye) {
    if (nettoye) syncCount();
  });

  /* Clic sur l'icone panier : ouvrir le tiroir plutot que d'aller sur /cart. */
  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest ? event.target.closest(CART_LINK) : null;
      if (!link || link.closest('cart-drawer')) return;
      var el = drawer();
      if (!el || typeof el.open !== 'function') return;
      event.preventDefault();
      el.open(link);
    },
    false
  );

  /* ── 2. Ajout depuis le tiroir ────────────────────────────────── */

  /* Re-rend tout #CartDrawer a partir du Liquid frais : la barre de livraison,
     les lignes, l'upsell et le sous-total bougent ensemble. */
  function repaint(addedId) {
    var el = drawer();
    if (!el) {
      window.location.reload();
      return Promise.resolve();
    }
    return fetch('/?sections=cart-drawer')
      .then(function (r) {
        return r.json();
      })
      .then(function (sections) {
        el.classList.remove('is-empty');
        el.renderContents({ id: addedId, sections: sections });
      });
  }

  function setBusy(on) {
    adding = on;
    document.querySelectorAll('[data-kd-add]').forEach(function (btn) {
      btn.disabled = on;
    });
  }

  /* Le prix affiche doit suivre la variante choisie : sur GravityTrain, Starter
     et Full Set ne sont pas au meme prix. */
  document.addEventListener(
    'change',
    function (event) {
      var select = event.target.closest ? event.target.closest('[data-kd-variant]') : null;
      if (!select) return;
      var card = select.closest('.kd-up__card');
      var opt = select.options[select.selectedIndex];
      if (!card || !opt) return;
      var now = card.querySelector('[data-kd-now]');
      var was = card.querySelector('[data-kd-was]');
      var save = card.querySelector('[data-kd-save]');
      if (now && opt.dataset.price) now.textContent = opt.dataset.price;
      if (was) {
        was.hidden = !opt.dataset.was;
        if (opt.dataset.was) was.textContent = opt.dataset.was;
      }
      /* Le pourcentage d'economie suit la variante : sur GravityTrain le Starter
         et le Full Set n'ont pas la meme remise. */
      if (save) {
        save.hidden = !opt.dataset.save;
        if (opt.dataset.save) save.textContent = opt.dataset.save;
      }
    },
    false
  );

  document.addEventListener(
    'click',
    function (event) {
      var btn = event.target.closest ? event.target.closest('[data-kd-add]') : null;
      if (!btn) return;
      event.preventDefault();
      if (adding) return;

      var card = btn.closest('.kd-up__card');
      var select = card ? card.querySelector('[data-kd-variant]') : null;
      var id = parseInt((select && select.value) || btn.getAttribute('data-kd-vid'), 10);
      if (!id) return;

      var label = btn.textContent;
      setBusy(true);
      btn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add');
          return r.json();
        })
        .then(function (data) {
          var addedId = data.items ? data.items[0].id : data.id;
          /* Volontairement pas de publish(cartUpdate) ici : CartDrawerItems y est
             abonne et refetcherait ?section_id=cart-drawer en parallele de notre
             repaint, deux rendus concurrents pour le meme resultat. */
          return repaint(addedId).then(function () {
            return syncCount();
          });
        })
        .catch(function () {
          btn.textContent = label;
        })
        .finally(function () {
          setBusy(false);
        });
    },
    false
  );

  /* Retirer un produit doit emporter ses supplements. Ils sont presentes comme
     des options du produit et n'ont plus de croix a eux : sans ca, on retire le
     puzzle et le client continue de payer la gravure et les poignees, seules
     dans le panier.

     Interception en phase de CAPTURE pour passer avant le handler de Dawn, qui
     ne sait retirer qu'une ligne a la fois. */
  document.addEventListener(
    'click',
    function (event) {
      if (!event.target.closest) return;
      var bouton = event.target.closest('cart-remove-button');
      if (!bouton) return;

      var ligne = bouton.closest('.cart-item');
      var titre = ligne && ligne.getAttribute('data-kd-title');
      var cle = ligne && ligne.getAttribute('data-kd-key');
      if (!titre || !cle) return;

      var rattaches = document.querySelectorAll('[data-kd-addon][data-kd-for="' + titre.replace(/"/g, '\\"') + '"]');
      if (!rattaches.length) return; /* pas de supplement : Dawn fait le travail */

      event.preventDefault();
      event.stopPropagation();

      var updates = {};
      updates[cle] = 0;
      Array.prototype.forEach.call(rattaches, function (r) {
        var k = r.getAttribute('data-kd-key');
        if (k) updates[k] = 0;
      });

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('update');
          /* On court-circuite Dawn, donc aucun cartUpdate n'est publie : le
             menage des cadeaux ne se ferait pas tout seul ici. */
          return nettoyerCadeaux();
        })
        .then(function () {
          return repaint(null);
        })
        .then(function () {
          return syncCount();
        })
        .catch(function () {
          window.location.reload();
        });
    },
    true
  );

  /* La classe is-empty est posee par Liquid au chargement de la page. Dawn ne la
     retire que de .drawer__inner, jamais de <cart-drawer>, donc apres un ajout
     AJAX sur une page ouverte avec le panier vide elle reste collee : le header
     et la liste des articles tombent a zero de hauteur et le tiroir s'ouvre
     blanc. C'est le parcours du premier achat, il faut le tenir.

     On la resynchronise sur le seul fait qui compte, la presence de lignes.
     Observation limitee a childList/subtree : observer les attributs bouclerait,
     puisqu'on modifie justement une classe sur le noeud observe. */
  function syncEmptyClass(drawer) {
    if (!drawer) return;
    var vide = drawer.querySelectorAll('.cart-item').length === 0;
    drawer.classList.toggle('is-empty', vide);
  }

  function watchEmptyClass() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.dataset.kdEmptyWatched) return;
    drawer.dataset.kdEmptyWatched = '1';
    syncEmptyClass(drawer);
    new MutationObserver(function () {
      syncEmptyClass(drawer);
    }).observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchEmptyClass, false);
  } else {
    watchEmptyClass();
  }
})();
